import type {
  IAuthService,
  AuthResult,
} from '@domain/services';

export class LoginUseCase {

  constructor(
    private readonly authService: IAuthService
  ) {}

  async execute(
    email: string,
    password: string
  ): Promise<AuthResult> {

    if (!email.trim()) {
      throw new Error(
        'El email es obligatorio'
      );
    }

    if (!password.trim()) {
      throw new Error(
        'La contraseña es obligatoria'
      );
    }

    return await this.authService.login({
      email,
      password,
    });
  }
}